module.exports = __webpack_public_path__ + "static/2006-layer-2-1d2cb412e9514f95e35230b5f0408738.png";